// Chakra imports
import {
    Box,
    Button,
    Flex,
    Image,
    Text,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalBody,
    ModalFooter, Modal, Heading,
} from "@chakra-ui/react";
// Assets
import React from "react";
import TruncatedText from "../text/TruncatedText";

export default function RentalPreview({ isOpen, onClose, data }) {
    const {bedrooms, guests, size, title, description, place, picture, price} = data;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay/>
            <ModalContent bgColor="white">
                <ModalCloseButton/>
                <ModalBody>
                    <Box mt='20px'>
                        <Heading size='xl'>Voransicht</Heading>
                        <Text>So wird dein Inserat in den Suchergebnissen aussehen</Text>
                        <Box borderWidth='1px' borderRadius='lg' mt={5} overflow='hidden'>
                            {picture ? <Image height={'250px'} width={'100%'} objectFit={'cover'} src={picture.url}/> :
                                <Box height={'250px'} bg='gray.500'/>}
                            <Box p='6'>
                                <Text>{place}</Text>
                                <Heading size='md'>{title}</Heading>
                                <TruncatedText content={description} maxLength={100}/>
                                <Text>{bedrooms ? `${bedrooms} Schlafzimmer` : ''}{guests ? `, ${guests} Gäste` : ''}{size ? `, ${size}qm` : ''}</Text>
                                <Flex mt={5}>
                                    <Box>
                                        <Text fontSize='lg'>ab {price} €</Text>
                                        <Text fontSize='xs'>für eine Nacht</Text>
                                    </Box>
                                </Flex>
                            </Box>
                        </Box>
                    </Box>
                </ModalBody>

                <ModalFooter>
                    <Button variant='ghost' onClick={onClose}>
                        Schließen
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
